import { ListItem, Stack, styled } from '@mui/material';

interface OptionListItemProps {
  isChecked?: boolean;
}

export const OptionListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})<OptionListItemProps>(({ isChecked = true }) => {
  const border = isChecked
    ? '2px solid var(--mui-palette-primary-main)'
    : '1px solid var(--mui-palette-divider)';
  return {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    alignItems: 'flex-start',
    padding: '16px 24px',
    borderRadius: 'var(--mui-shape-borderRadius)',
    border,
    marginBottom: '8px',
    gap: 0,

    '.content': {
      height: 0,
      overflow: 'hidden',

      '> :first-child': {
        marginTop: '20px',
      },

      '&.expanded': {
        height: 'auto',
        cursor: 'default',
      },
    },
  };
});

export const OptionListItemContent = ({
  children,
  isExpanded,
}: {
  children: React.ReactNode;
  isExpanded: boolean;
}) => {
  return (
    <Stack
      alignSelf='stretch'
      margin={'0 0 24px 36px'}
      className={`content ${isExpanded ? 'expanded' : ''} mb-[24px] ml-[36px]`}
    >
      {children}
    </Stack>
  );
};
